import { BuscaCidadaoListagemTematicaSaudeMulherQuery } from 'graphql/types.generated'

export type CidadaoListagemSaudeMulherQueryResult = BuscaCidadaoListagemTematicaSaudeMulherQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemSaudeMulherQueryModel = CidadaoListagemSaudeMulherQueryResult['content'][0]

export const IDADE_FORA_DE_RASTREIO_TEXT = 'Fora da idade para rastreio.'
